import InvoicesChangelogTable from './components/InvoicesChangelogTable';

const InvoicesChangelog = () => {
  return <InvoicesChangelogTable />;
};

export default InvoicesChangelog;
